// Action Types
const SET_WORD_FOR_WORD = "advancedView/SET_WORD_FOR_WORD";
const SET_SANSKRIT = "advancedView/SET_SANSKRIT";
const SET_TRANSLATION = "advancedView/SET_TRANSLATION";
const SET_COMMENTARY = "advancedView/SET_COMMENTARY";
const SET_SEARCH_TERM = "advancedView/SET_SEARCH_TERM";

// Action Creators
export const advancedViewActions = {
	setSanskrit: (isOn) => ({ type: SET_SANSKRIT, payload: isOn }),
	setWordForWord: (isOn) => ({ type: SET_WORD_FOR_WORD, payload: isOn }),
	setTranslation: (isOn) => ({ type: SET_TRANSLATION, payload: isOn }),
	setCommentary: (isOn) => ({ type: SET_COMMENTARY, payload: isOn }),
	setSearchTerm: (searchTerm) => ({ type: SET_SEARCH_TERM, payload: searchTerm }),
};

// Initial State
export const getInitialAdvancedViewState = () => {
	const savedSanskrit = localStorage.getItem("sanskrit");
	const savedWordForWord = localStorage.getItem("wordForWord");
	const savedTranslation = localStorage.getItem("translation");
	const savedCommentary = localStorage.getItem("commentary");

	return {
		sanskrit: savedSanskrit !== null ? savedSanskrit === "true" : true,
		wordForWord: savedWordForWord !== null ? savedWordForWord === "true" : true,
		translation: savedTranslation !== null ? savedTranslation === "true" : true,
		commentary: savedCommentary !== null ? savedCommentary === "true" : true,
		searchTerm: "",
	};
};

// Reducer.
export const advancedViewReducer = (
	state = getInitialAdvancedViewState(),
	action,
) => {
	switch (action.type) {
	case SET_WORD_FOR_WORD:
		// Save the wordForWord state to localStorage
		localStorage.setItem("wordForWord", action.payload);
		return { ...state, wordForWord: action.payload };
	case SET_SANSKRIT:
		// Save the sanskrit state to localStorage
		localStorage.setItem("sanskrit", action.payload);
		return { ...state, sanskrit: action.payload };
	case SET_TRANSLATION:
		// Save the translation state to localStorage
		localStorage.setItem("translation", action.payload);
		return { ...state, translation: action.payload };
	case SET_COMMENTARY:
		// Save the commentary state to localStorage
		localStorage.setItem("commentary", action.payload);
		return { ...state, commentary: action.payload };
	case SET_SEARCH_TERM:
		return { ...state, searchTerm: action.payload };
	default:
		return state;
	}
};

// Selectors
export const advancedViewSelectors = {
	isWordForWordOn: (state) => state.advancedView.wordForWord,
	isSanskritOn: (state) => state.advancedView.sanskrit,
	isCommentaryOn: (state) => state.advancedView.commentary,
	isTranslationOn: (state) => state.advancedView.translation,
	isAdvancedView: (state) => {
		const { translation, sanskrit, wordForWord, commentary } = state.advancedView;
		return !( translation && !sanskrit && !wordForWord && !commentary );
	},
	getSearchTerm: (state) => state.advancedView.searchTerm,
};
